import { render, staticRenderFns } from "./TributeSetup.vue?vue&type=template&id=3570f85b&scoped=true"
import script from "./TributeSetup.vue?vue&type=script&lang=js"
export * from "./TributeSetup.vue?vue&type=script&lang=js"
import style0 from "./TributeSetup.vue?vue&type=style&index=0&id=3570f85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570f85b",
  null
  
)

export default component.exports